// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { theme } from '@lmc/ui-kit'
import { capitalize, filter, get, without } from 'lodash'
import AnimateHeight from 'react-animate-height'
import RiskValue from '../../carePlans/RiskValue'
import { FormFieldLayout, Icon } from '../../generic'

export default function CheckboxField({
  disabled,
  errors,
  formKey,
  onChange,
  options,
  optionStyle,
  readOnly,
  style,
  values,
  ...props
}) {
  const currentValue = get(values, formKey)
  const error = get(errors, formKey)
  const selectedOptions = getSelectedOptions(currentValue, options)

  if (readOnly) {
    return <div>{selectedOptions.map(ReadOnly)}</div>
  }

  return (
    <FormFieldLayout hasErrors={!!error} {...props}>
      <div style={{ ...style, ...styles.wrapper }}>
        {options.map((option, i) => {
          const isChecked = Array.isArray(currentValue)
            ? selectedOptions.includes(option)
            : false

          let borderColor
          if (error) {
            borderColor = colors.red
          } else if (isChecked) {
            borderColor = theme.color.status.primary
          } else {
            borderColor = colors.grey
          }

          return (
            <div
              className="lmc-option-field"
              key={i}
              onClick={
                disabled
                  ? undefined
                  : () =>
                      onChange({
                        key: formKey,
                        value: getChangeValue(currentValue, option, i)
                      })
              }
              style={{
                borderColor,
                ...optionStyle,
                ...(disabled ? { opacity: 0.5, cursor: 'default' } : {})
              }}
            >
              <div style={styles.valueContainer}>
                {option.risk && (
                  <RiskValue risk={option.risk} value={option.value} />
                )}
                <span style={styles.checkboxLabel}>
                  {option.label || capitalize(option.value)}
                </span>
              </div>
              <Icon
                name={isChecked ? 'checkbox-on' : 'checkbox-off'}
                fill={isChecked ? theme.color.status.primary : null}
                size={24}
                style={styles.icon}
              />
            </div>
          )
        })}
      </div>
      <AnimateHeight animateOpacity duration={200} height={error ? 'auto' : 0}>
        <div style={styles.error}>{error}</div>
      </AnimateHeight>
    </FormFieldLayout>
  )
}

const ReadOnly = (option, i) => (
  <div
    className={
      option.risk
        ? 'lmc-risk-option-field-read-only'
        : 'lmc-option-field-read-only'
    }
    key={i}
    style={styles.readOnly}
  >
    <div style={styles.valueContainer}>
      {option.risk && <RiskValue risk={option.risk} value={option.value} />}
      <span style={styles.checkboxLabel}>
        {option.label || capitalize(option.value)}
      </span>
    </div>
  </div>
)

const getSelectedOptions = (currentValue, options) => {
  if (!currentValue) {
    return null
  }
  return filter(options, (option, i) => {
    const chosenValue = option.risk ? i : option.value
    return currentValue.includes(chosenValue)
  })
}

const getChangeValue = (currentValue, option, index) => {
  const value = option.risk ? index : option.value
  if (!currentValue || !Array.isArray(currentValue) || !currentValue.length) {
    return [value]
  }
  if (currentValue.includes(value)) {
    // deselecting an option
    return currentValue.length === 1 ? [] : without(currentValue, value)
  }
  return [...currentValue, value]
}

const styles = {
  checkboxLabel: {
    alignSelf: 'center',
    display: 'block',
    marginRight: 5
  },
  error: {
    color: colors.red,
    fontSize: 11,
    paddingTop: 2
  },
  icon: {
    flexShrink: 0
  },
  readOnly: {
    marginRight: 12
  },
  valueContainer: {
    alignItems: 'center',
    display: 'flex'
  },
  wrapper: {
    display: 'flex',
    flexFlow: 'row wrap',
    marginBottom: '-12px'
  }
}

CheckboxField.propTypes = {}
